import { createFileRoute } from "@tanstack/react-router";
import { SharePage } from "@/features/share/SharePage";

export const Route = createFileRoute("/memos/shares/$token")({
  component: SharePage,
});
